<template>
  <div class="er002">
   
      
      
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
         
            <div class="mainWrao">
              <div class="tableWrap">
                <div class="times">
                  <span class="machineID">{{showMachineID}}</span>
                  <span class="range" v-show="timeArr.length !== 0">{{timeArr[0]}} ~ {{timeArr[1]}}</span>
                </div>
                <!-- 表格 -->
                <el-table
                  v-loading="tableLoading"
                  :data="tableData"
                  :header-cell-style="titleStyle"
                  :cell-style="cellStyle"
                  style="width: 100%;margin-top:20px;">
                  <el-table-column
                    class-name="merge"
                    width="120"
                    >
                    <template slot="header">
                      <p class="w">{{$t('er02.title1')}}</p>
                      <p class="w">{{showMachineID}}</p>
                      <span class="w">{{$t('er02.title2')}}</span>
                    </template>
                    <template slot-scope="scope">
                      <div style="text-align:center;">
                        <p><span>{{scope.row.code}}</span></p>
                        <p><span>{{scope.row.event}}</span></p>
                        <p></p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="100"
                    class-name="merge"
                    >
                    <template slot="header">
                      <p style="visibility: hidden;">1</p>
                      <p style="visibility: hidden;">1</p>
                      <p class="w" v-show="tableTitle.tireInfoNum !== ''">{{tableTitle.tireInfoNum}} {{$t('ReloadingStatistics.tires')}}</p>
                    </template>
                    <template>
                      <div style="text-align:center;">
                        <p>{{$t('er02.Frequency')}}</p>
                        <p>{{$t('er02.Occurred')}}</p>
                        <p>{{$t('er02.LostTime')}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    class-name="merge"
                    >
                    <template slot="header">
                      <p class="white">{{$t('er02.title3')}}</p>
                      <p v-show="tableTitle.statisticAllNum !== ''" class="white">{{tableTitle.statisticAllNum}} {{$t('ReloadingStatistics.frequency')}}</p>
                      <p v-show="tableTitle.statisticAllTime !== ''" class="white">{{tableTitle.statisticAllTime}} {{$t('ReloadingStatistics.minute')}}</p>
                    </template>
                    <template slot-scope="scope">
                      <div style="text-align:right;">
                        <p>{{scope.row.unit}} {{$t('ReloadingStatistics.frequency')}}</p>
                        <p></p>
                        <p>{{scope.row.unitTime}} {{$t('ReloadingStatistics.minute')}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                  class-name="merge">
                    <template slot="header">
                      <ul class='hoursList'>
                        <li v-for="(item, index) in tableTitle.list" :key="index">
                          <p>{{item.hours}}</p>
                          <p>{{item.statisticNum}} {{$t('ReloadingStatistics.frequency')}}</p>
                          <p>{{item.statisticTime}} {{$t('ReloadingStatistics.minute')}}</p>
                        </li>
                      </ul>
                    </template>
                    <template slot-scope="scope">
                      <ul class="infoList">
                        <li style="position:relative;border-left:1px solid #efefef;" v-for="(item,index) in scope.row.list" :class="{'err': item.color}" :key="index">
                          <p>{{item.statisticNum}}</p>
                          <p>{{item.firstTime}}</p>
                          <p v-show="item.durationTime !== ''">{{item.durationTime}} {{$t('ReloadingStatistics.second')}}</p>
                          <p v-show="item.durationTime === ''"></p>
                        </li>
                      </ul>
                    </template>
                  </el-table-column> 
                </el-table>

              
              </div>       
            </div>
          
        </el-scrollbar>
      
    
    
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'



export default {
  name: 'ER002',
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [Number(this.$store.state.defaultShopId), Number(this.$store.state.defaultId)],
      tableLoading: false,
      // 表格数据
      tableData:[],
      tableTitle: {
        tireInfoNum: '',
        statisticAllTime: '',
        statisticAllNum: '',
        list:[]
      },
      // 时间
      testTime:['a','b','c','d','e','f','g'],
      selectTime: null,
      nowTime: null,
      // 当前机械的班组开始时间
      workTime: '',
      // 按钮边显示的时间范围
      timeArr: [],
      // 时间选择器禁用
      pickerOptions:{
        disabledDate: (time) =>{
          return time.getTime() > this.nowTime
        }
      },
      showMachineID: '',
      disabled:true,
      timer: '',
      defaultid: ''
    }
  },

  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getId()
  },
  destroyed(){
    clearInterval(this.timer)
  },
  methods: {
    getId(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.defaultid = res.data.machine.id
          _this.getTableData()
          _this.timing()
        }
      })
    },
     //定时刷新数据
    timing(){
      let _this = this
      this.timer=setInterval(function(){
        _this.getTableData()
      },180000)
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 获取当前日期和早班开始时间
    getdate(){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getReloadingTime',
        params:{
          machineId: _this.machineID[1],
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.selectTime = res.data.date
          _this.nowTime = res.data.date
          _this.workTime = res.data.time
          _this.timeRange()
        } else {
          _this.$message.error(res.data.msg)
        }
      }).then(function(){
        _this.getTableData()
      })
    },
    // 按钮边显示的时间范围
    timeRange(){
      let startTime = `${formatDate(new Date(this.selectTime), 'yyyy/MM/dd')}${this.workTime}`
      let endTime = `${formatDate(new Date(this.selectTime+86400000), 'yyyy/MM/dd')}${this.workTime}`
      this.timeArr = [startTime, endTime]
  
    },
    // 获取表格数据
    getTableData(){
      let timestamp = (new Date()).getTime();
      let startstamp = (new Date()).getTime() - 43200000
      let start =`${formatDate(new Date(startstamp), 'yyyy/MM/dd hh')}:30:00`
      let end = `${ formatDate( new Date(timestamp), 'yyyy/MM/dd hh')}:30:00`
      this.timeArr=[start,end]
      this.tableLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getSingleEquipmentReloadingAnalysis',
        params:{
          machineId: _this.defaultid,
          startTime: _this.timeArr[0],
          endTime: _this.timeArr[1],
          bigScreen:2,
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.tableData = res.data.data
          _this.tableTitle = res.data.data2
          _this.showMachineID = res.data.machine.nameEn
        } else {
          _this.$message.error(res.data.msg)
        }
        _this.tableLoading = false
        _this.disabled = false
      })
    },
    tableRowClassName({row}) {
      if (row.color === true) {
        return 'warning-row';
      }
      return '';
    },
    //导出
    exportExcel(){
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      if(this.machineID[1] && this.timeArr[0] && this.timeArr[1]){
        let urlData = '?machineId=' + this.machineID[1] + '&startTime=' + this.timeArr[0] + '&endTime=' + this.timeArr[1] + '&language='+ this.$store.state.lang + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        window.open('/url/excelExportReloadingAnalysis' + urlData, '_blank')
      }
                 
    },
    titleStyle(){
      return 'background-color:#305496;'
    },
    cellStyle({ columnIndex}){
      if (columnIndex === 0) {
        return 'background-color:#bdd7ee;'
      }else if(columnIndex === 1){
        return 'background-color:#bdd7ee;border-left:1px solid #ffffff;'
      }
    }
    
  }
  
}
</script>
<style scoped>

.mainWrao{
  height: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  padding: 1.42rem 15px;
}
.times .picker{
  margin-right:15px;
}
.times button{
  padding: 12px;
}
.times .range{
  font-size: 14px;
  margin-left: 25px
}
.times .export{
  float:right;
  width: 100px;
}
.times .machineID{
  font-weight: bold;
  font-size: 14px;
  margin-left: 25px
}
.hoursList,.infoList{
  overflow: hidden;
}
.hoursList li{
  width: 7.14rem;
  float: left;
  font-weight: bold;
  text-align: right;
  color:#fff;
}
.infoList li{
  width:  7.14rem;
  float: left;
  text-align: right
}
.infoList .err p{
  color: red;
}
.tableWrap .el-table p{
  min-height: 1.64rem;
  line-height: 1;
}
.white{
  text-align: right;
  color: #fff;
  font-weight: bold;
}
.w{
  color: #fff;
  font-weight: bold;
  display: block
}
.merge p , .merge span{
  font-size: 1rem!important;
  min-height: 1.64rem;
  line-height: 1;
}
</style>

